<template>
  <div class="bg-color-black-super">
    <div class="centered">
      <div class="grid height-100 align-content-center">
        <div class="grid__cell-lg-20 offset-lg-2">
          <div class="footer">
            <div class="footer__copyright text-color-white">
              <div class="footer__dates">© 2003–2021 </div>
              <div class="footer__company"> ООО «Мега – Ф Сервис»</div>
            </div>
            <div class="footer__description text-color-white">Комплекс услуг по определению координат и маршрутов передвижения автомобиля, обеспечению его безопасности, защите от угона и диагностике неисправностей двигателя.</div>
            <!--
            <div class="footer__lang">
              <div class="lang">
                <div class="lang__item">
                  <span class="lang__toggler lang__toggler&#45;&#45;active">Русский</span>
                </div>
                <div class="lang__item">
                  <span class="lang__toggler">English</span>
                </div>
              </div>
            </div>
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "Footer"
}
</script>
